import React from 'react';
import Polls from '../../Sections/EarnedPointsSection/CurrentPolls/Polls';
import { isAttemptedPoll } from '../../Sections/EarnedPointsSection/CurrentPolls/pollData';

const PollList = ({ poll, index, userId, onPollSubmit, isLivePoll, gameId }) => {
    const { pollTitle, pollOptions, _id } = poll || {};
    const options = pollOptions?.map((option) => ({
        label: option?.optionTitle,
        votes: option?.votes,
        id: option?._id,
        voteDetails: option?.voteDetails
    }));

    // Check if the poll is attempted by the user
    const isPollAttempted = isAttemptedPoll(pollOptions, userId, gameId);

    return (
        <Polls
            poll={poll}
            question={pollTitle}
            options={options}
            pollIndex={index}
            pollId={_id}
            userId={userId}
            onSubmit={() => onPollSubmit(index)}
            isLivePoll={isLivePoll}
            isPollAttempted={isPollAttempted}
            gameId={gameId}
        />
    );
};

export default PollList;
